import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryIcons: Record<string, string> = {
  romance: 'ri-heart-line',
  fantasy: 'ri-magic-line',
  action: 'ri-sword-line',
  mystery: 'ri-search-eye-line',
  bl: 'ri-double-quotes-l',
  school: 'ri-building-line',
  comedy: 'ri-emotion-laugh-line',
  historical: 'ri-ancient-gate-line',
};

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            八大分类覆盖各类韩漫题材，无论你喜欢什么类型，这里都能找到
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${categoryIcons[cat.slug] || 'ri-booklet-line'} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">{cat.name}</h3>
                <p className="text-xs text-foreground-400 hidden sm:block">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}